export enum SickLeaveBaseType {
  GrossZus = 0,
  GrossZusSubstractRewards = 1,
  FromContract = 2,
}
